import { Routes } from '@angular/router';
import { PeopleComponent } from './people/people.component';
import { ProductsComponent } from './products/products.component';
import { ResourcesComponent } from './resources/resources.component';
import { LocationsComponent } from './locations/locations.component';
import { HomeComponent } from './home/home.component';
import { ProductComponent } from './products/product/product.component';
import { MyharrellsloginComponent } from './myharrellslogin/myharrellslogin.component';
import { MyharrellsComponent } from './myharrells/myharrells.component';
import { MyharrellsaccountsetupComponent } from './myharrellsaccountsetup/myharrellsaccountsetup.component';
import { MyharrellspasswordresetComponent } from './myharrellspasswordreset/myharrellspasswordreset.component';
import { MarketsComponent } from './markets/markets.component';
import { GolfComponent } from './markets/golf/golf.component';
import { LawnComponent } from './markets/lawn/lawn.component';
import { HorticultureComponent } from './markets/horticulture/horticulture.component';
import { TurfComponent } from './markets/turf/turf.component';
import { SpecialtyComponent } from './markets/specialty/specialty.component';
import { KnowledgeComponent } from './resources/knowledge/knowledge.component';
import { BlogComponent } from './resources/knowledge/blog/blog.component';
import { ContactsComponent } from './contacts/contacts.component';
import { AboutComponent } from './about/about.component';
import { FindrepComponent } from './people/findrep/findrep.component';
import { RepComponent } from './rep/rep.component';
import { TeamsComponent } from './people/teams/teams.component';
import { FormsComponent } from './forms/forms.component';
import { CalculatorsComponent } from './calculators/calculators.component';
import { CareersComponent } from './careers/careers.component';
import { BillAndHoldAgreementComponent } from './bill-and-hold-agreement/bill-and-hold-agreement.component';
import { SearchComponent } from './search/search.component';
import { CartComponent } from './cart/cart.component';
import { PeatComponent } from './products/peat/peat.component';
import { EducationComponent } from './education/education.component';
import { MatrixComponent } from './matrix/matrix.component';
import { PostComponent } from './post/post.component';

export const routes: Routes = [
    {
        path: 'people', component: PeopleComponent,
    },
    {
        path: 'findrep', component: FindrepComponent,
    },    
    {
        path: 'teams', component: TeamsComponent,
    },      
    {
        path: 'rep', component: RepComponent,
    },      
    {
        path: 'products', component: ProductsComponent,
    },
    {
        path: 'product', component: ProductComponent,
    },    
    {
        path: 'peat', component: PeatComponent,
    },    
    {
        path: 'cart', component: CartComponent,
    },       
    {
        //this is for old links in the wild that followed this path structure from legacy harrells.com site 
        //an example is https://www.harrells.com/Products/ProductDetail?sku=200130
        path: 'Products/ProductDetail', component: ProductComponent, 
    },
    {
        path: 'markets', component: MarketsComponent,
    },
    {
        path: 'golf', component: GolfComponent,
    },    
    {
        path: 'lawn', component: LawnComponent,
    }, 
    {
        path: 'horticulture', component: HorticultureComponent,
    }, 
    {
        path: 'turf', component: TurfComponent,
    }, 
    {
        path: 'specialty', component: SpecialtyComponent,
    }, 
    {
        path: 'resources', component: ResourcesComponent,
    },    
    {
        path: 'blog', component: BlogComponent,
    },   
    {
        //this is for old links in the wild that followed this path structure from legacy harrells.com site 
        //an example is https://www.harrells.com/Blog/Post/all-about-botrytis
        //not the :id below.  that is to acommadate the fact that this path example has the blog name 
        //after the last / instead of using a qs parameter 
        path: 'Blog/Post/:id', component: BlogComponent, 
    },    
    {
        path: 'knowledge', component: KnowledgeComponent,
    }, 
    {
        path: 'locations', component: LocationsComponent, 
    },
    {
        path: 'contacts', component: ContactsComponent,
    },    
    {
        path: 'contact', component: ContactsComponent,
    },        
    {
        path: 'about', component: AboutComponent,
    },        
    {
        path: 'forms', component: FormsComponent,
    },        
    {
        path: 'calculators', component: CalculatorsComponent,
    },       
    {
        path: 'careers', component: CareersComponent,
    },           
    { 
        path: 'education', component: EducationComponent, 
    },
    {
        path: 'myharrellslogin', component: MyharrellsloginComponent,
    },       
    {
        path: 'myharrells', component: MyharrellsComponent,
    },    
    {   
        path: 'matrix', component: MatrixComponent, //education posts in matrix 
    },
    {   
        path: 'post', component: PostComponent, //education posts
    },    
    {
        path: 'myharrellsaccountsetup', component: MyharrellsaccountsetupComponent,
    },      
    {
        path: 'myharrellspasswordreset', component: MyharrellspasswordresetComponent,
    },
    {
        path: 'search', component: SearchComponent,
    },
    {
        path: 'billandholdagreement', component: BillAndHoldAgreementComponent,
    },
    {
        //this is for old links in the wild that followed this path structure from legacy harrells.com site 
        //an example is https://harrells.azurewebsites.net/home/BillAndHoldAgreement/0C3FD42A-9D63-4108-9007-AD69DFB214CF
        path: 'home/BillAndHoldAgreement/:id', component: BillAndHoldAgreementComponent, 
    },  
    {
        path: 'home', component: HomeComponent,
    },      
    {
        path: '', component: HomeComponent,
    },
    {
        path: '**', component: HomeComponent,
    }
];